import { courseCategoriesApi } from 'Api/axios/course-categories-api';
import { useState, useEffect } from 'react';
import type { CourseCategoryFilterI, CourseCategoryI } from 'types';

interface Props {
  init?: boolean;
}

const useCourseCategoriesApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<Array<CourseCategoryI>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async (filters: CourseCategoryFilterI = {}) => {
    setLoading(true);
    const response = await courseCategoriesApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchCategories();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchCategories,
  };
};

export default useCourseCategoriesApi;
